export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8647.c5cc5fd4.jpg";